

import { UIAmountInput } from "components/ui";
import React from "react";
import { SVGAsset } from "res";

/**
 * @function MobileACHTransfersFromTableRow
 * @param {STRING} nickname - Sets the ACH account nickname text. 
 * @param {STRING} amount - Sets the ACH dollar amount for text input.
 * @return {React.Component}
 * @exported true
 * @description - This is the table row used for the mobile One Time ACH From table view.
 */
export default function MobileACHTransfersFromTableRow(props) {
    const achFromAccount = props.achFromAccount ?? {};
    const account = achFromAccount.account ?? {};
    const onACHFromAccountChange = props.onACHFromAccountChange ?? (() => {});
    const onACHFromAccountDelete = props.onACHFromAccountDelete ?? (() => {});
    const nickname = props.nickname ?? "[nickname]";
    const amount = props.amount ?? "[amount]";

    return (
        <div className="mobile-one-time-ach-from-row">
            <div className="flex-container align-center">
                <div className="flex-width">
                    <div className="detail-row">
                        <span className="detail-label">Nickname</span> <span className="detail-text">{ account.nickname }</span>
                    </div>
                    <div className="detail-input-row">
                        <UIAmountInput value={ achFromAccount.amount.amount } onChange={ onACHFromAccountChange(achFromAccount) } />
                    </div>
                </div>
                <div className="set-width text-right">
                    <a onClick={ onACHFromAccountDelete(achFromAccount) }>
                        <SVGAsset id="TrashcanXIcon" className="clickable trash-can-x-icon" />
                    </a>
                </div>
            </div>
        </div>
    )
}
